export default __webpack_public_path__ + "static/media/bookmark-filled.6e5c8fd2.svg";